export function browserTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function withStoredTimeZone(timeZones: string[], stored: string | null): string[] {
    if (stored == null || stored === '' || timeZones.includes(stored)) {
        return timeZones;
    }
    return [...timeZones, stored].sort();
}
